<script setup>
import AppLayout from "../../Layouts/AppLayout.vue";
import PrimaryButton from "../../Components/PrimaryButton.vue";
import MediaUpload from "../../Components/Common/Media/MediaUpload.vue";
import {useHelpers} from "../../helpers";
import {usePage} from "@inertiajs/inertia-vue3";

defineProps({
  media: Object
});
const helpers = useHelpers();
const currentUser = usePage().props.value.auth.user;
</script>

<template>
  <AppLayout title="Human Resources">
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">
        Human Resources
      </h2>
    </template>

    <div class="max-w-full py-10 sm:px-6 lg:px-8">
      <!--<p class="mb-5">
        <a href="/content/humanresources/timeclock/index.php">
          <PrimaryButton>TimeClock</PrimaryButton>
        </a>
      </p>-->

      <MediaUpload
        :media-input="media"
        :can-see-upload-form="helpers.userHasPermission(currentUser, 'admin')"
        :can-modify-media-details="helpers.userHasPermission(currentUser, 'admin')"
        :hide-save="false"
        media-location="hr"
      ></MediaUpload>
    </div>
  </AppLayout>
</template>
